import { Coating, CoatingArea, Commands, Events, eventsManager, FloorCoatingArea, math } from "@rhinov/savane-js";
import { PlanManager } from "../../cocosPlan";



export class CoatingsComponentController {

    component: Coating | CoatingArea | FloorCoatingArea

    isFrontView = (): boolean => {
        return (PlanManager.getInstance().isFrontView());
    };

    constructor(component: Coating) {
        this.component = component;
    }

    /**
    * Remove component from entity
    *
    **/
    removeComponent() {
        PlanManager.getInstance().executeCommand(new Commands.DeleteComponentCommand(this.component, true));
    };

    getValueProperty(name: string, component: Coating): number {
        switch (name) {
            case 'offsetX':
                return (Math.round(component.offset[0] * 100));
            case 'offsetY':
                return (Math.round(component.offset[1] * 100));
            case 'repeatX':
                return (Math.round(component.repeat[0] * 100));
            case 'repeatY':
                return (Math.round(component.repeat[1] * 100));
            default:
                return (component as any)[name];
        }
    }

    dispvalue(value: number): string {
        if (value === undefined || value === null)
            return ('');

        return value.toString();
    };


    getUpdateTileFGProperty(name: string, component: Coating, value: number) {
        switch (name) {
            case 'width':
                component.floorGeneratorSettings.tile.dimensions.width = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'length':
                component.floorGeneratorSettings.tile.dimensions.length = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'height':
                component.floorGeneratorSettings.tile.dimensions.height = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'maxWidth':
                component.floorGeneratorSettings.tile.dimensions.maxWidth = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'maxLength':
                component.floorGeneratorSettings.tile.dimensions.maxLength = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
        }
    }

    getUpdateJointFGProperty(name: string, component: Coating, value: number) {
        switch (name) {
            case 'width':
                component.floorGeneratorSettings.joint.dimensions.width = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'length':
                component.floorGeneratorSettings.joint.dimensions.length = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'height':
                component.floorGeneratorSettings.joint.dimensions.height = value * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
        }
    }

     /**
    * Config id edition
    *FIXME Only work for coating component by now
    **/
    changeConfigId(component: Coating, inc: number) {

        if (component === undefined) {
            return;
        }

        var newVal = component.colorIndex + inc;
        while (newVal < 1) {
            newVal += component.colors.length;
        }
        while (newVal > component.colors.length) {
            newVal -= component.colors.length;
        }
        component.colorIndex = newVal;
    };

    floorUpdated() {
        PlanManager.getInstance().saveInCache();
        if (!this.isFrontView()) {
            eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
        } else {
            eventsManager.instance.dispatch(Events.FRONTVIEW_FLOOR_GENERATOR_CHANGED);
        }
    }

    floorTranslated(component: Coating, offset: math.vec2) {
        PlanManager.getInstance().saveInCache();
        if (!this.isFrontView()) {
            eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_UPDATED, {component: component, offset: offset});
            eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
        } else {
            eventsManager.instance.dispatch(Events.FRONTVIEW_FLOOR_GENERATOR_CHANGED);
        }
    }

    getUpdateFGProperty(name: string, component: Coating, value: string | number | boolean) {
        var number = value as number;
        switch (name) {
            case 'bevelValue':
                component.floorGeneratorSettings.bevelValue = number * 10;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            case 'offsetX':
                var delta = (component.floorGeneratorSettings.offsetX - number * 10);
                component.floorGeneratorSettings.offsetX = number * 10;
                PlanManager.getInstance().saveInCache();
                this.floorTranslated(component, math.vec2.fromValues(-delta, 0));
                break;
            case 'offsetY':
                var delta = (component.floorGeneratorSettings.offsetY - number * 10);
                component.floorGeneratorSettings.offsetY = number * 10;
                PlanManager.getInstance().saveInCache();
                this.floorTranslated(component, math.vec2.fromValues(0, delta));
                break;
            default:
                component.floorGeneratorSettings[name] = value;
                PlanManager.getInstance().saveInCache();
                this.floorUpdated();
                break;
            }
    }

    getUpdateProperty(name: string, component: Coating, value: string | number | boolean) {
        var number = value as number
        switch (name) {
            case 'offsetX':
                component.offset[0] = number / 100;
                PlanManager.getInstance().saveInCache();
                eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, component);
                break;
            case 'offsetY':
                component.offset[1] = number / 100;
                PlanManager.getInstance().saveInCache();
                eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, component);
                break;
            case 'repeatX':
                component.repeat[0] = number / 100;
                PlanManager.getInstance().saveInCache();
                eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, component);
                break;
            case 'repeatY':
                component.repeat[1] = number / 100;
                PlanManager.getInstance().saveInCache();
                eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, component);
                break;
            case 'rotation':
                component[name] = number;
                PlanManager.getInstance().saveInCache();
                if (component.floorGeneratorSettings) {
                    if (!this.isFrontView()) {
                        eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
                    } else {
                        eventsManager.instance.dispatch(Events.FRONTVIEW_FLOOR_GENERATOR_CHANGED);
                    }
                }
                else {
                    eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, component);
                }
                break;
            case 'altitude':
                (component as FloorCoatingArea).altitude = number * 10;
                PlanManager.getInstance().saveInCache();
                break;
            case 'hangType':
                component.hangType = number;
                break;
            default:
                (component as any)[name] = value;
                PlanManager.getInstance().saveInCache();
        }
    }
}